// extracted by mini-css-extract-plugin
export default {"cardList":"style_cardList__laMRl"};